import { render, staticRenderFns } from "./ListDisplay.vue?vue&type=template&id=4b09b564&scoped=true&"
import script from "./ListDisplay.vue?vue&type=script&lang=ts&"
export * from "./ListDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./ListDisplay.vue?vue&type=style&index=0&id=4b09b564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b09b564",
  null
  
)

export default component.exports